/**
 * Created by Jasmine on 2018/3/6.
 */

import { observable } from "mobx";
import { request, apis } from "../../../utils/net";

const store = observable({
    sysData: {}, // 系统设置信息
    infoVisible: false, // 账户信息弹框显示
    companyInfo: {}, // 企业信息

    //获取系统设置数据
    getSystemData() {
        let promise = request({
            url: apis.getSystemView,
            method: "POST"
        });
        promise.then(res => {
            this.sysData = res;
        });

        return promise;
    },

    AuthList: [],

    // 应用授权查询
    getAppAuthList() {
        request({
            url: apis.appAuthList,
            method: 'GET'
        }).then(res => {
            // console.log('res1', res)
            this.AuthList = res
        });
    },

    // 获取企业信息
    getCompanyInfo() {
        return request({
            url: apis.getCompanyInfo
        }).then(res => {
            this.companyInfo = res
            return res
        });
    },
});

export default store;
